import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
export class ConditionRegistryText extends ConditionRegistryCategory {
    label = 'Text';
    constructor(parent) {
        super(parent);
        super.init();
    }
    textIncludesUnderscore = () => new ConditionRegistryItem({
        eval: ({ actor }) => {
            if (actor.type !== 'text')
                return false;
            return actor.textBasis.includes('_');
        },
    });
}
